import React, { FC } from 'react';
import { Icon } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import { ISocialCertificate } from '@src/types/resumeDetail/socialType';
import { ICampusCertificate } from '@/src/types/resumeDetail/campusType';
import './index.scss';

interface IProps {
  data: ISocialCertificate[] | ICampusCertificate[];
  type: string;
  setMode: Function;
}

// 社校共用
const CertificateView: FC<IProps> = (props) => {
  const { data, type, setMode } = props;

  const { campusResumeFormRefStore, socialResumeFormRefStore } = useRootStore();
  let storeRef;
  if (type === 'campus') {
    storeRef = campusResumeFormRefStore;
  }
  if (type === 'social') {
    storeRef = socialResumeFormRefStore;
  }

  const handleEdit = () => {
    setMode('edit');
    storeRef.setCurrentScrollRef('certificate_edit');
  };

  const visible = data?.find((item) => item.name);

  return (
    <div className="certificate_view model_view">
      {visible && (
        <>
          <div className="model_title">
            <div>证书</div>
            <div className="edit_icon" onClick={() => handleEdit()}>
              <Icon type="edit-o" style={{ color: '#A9AFB8', fontSize: 22 }} />
            </div>
          </div>
          <div className="model_main">
            {data?.map(
              (item) =>
                item?.name && (
                  <div className="model_list" key={item.renderId}>
                    <div className="certificate_name">
                      <span>{item.name}</span>
                    </div>
                  </div>
                ),
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default CertificateView;
